import React from "react";
import "../../pages/style.css";
import ProjectCard from "./ProjectCard";
import { Container, Row, Col } from "react-bootstrap";
import gymmanagement from "../../Assets/admin.png";
import uidesign from "../../Assets/UI Design4.png";
import quizapp from "../../Assets/quiz.jpg";
import musicwebsite from "../../Assets/login_png.jpg";
import foodwebsite from "../../Assets/foodwebsite.png";
import workoutapp from "../../Assets/workout.jpg";
import chatwithgpt from "../../Assets/chatgpt.jpeg";
import employeemanage from "../../Assets/emp1.png";

function Projectlist() {
  return (
    <div className="projectbackground">
      <Container fluid className="project-section">
        <Container>
          <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={foodwebsite}
                isBlog={false}
                title="Food Ordering Website"
                description="Food Ordering Website is a platform that allows you to order food from restaurants, or other types of food services."
                ghLink="https://github.com/anmolkumar1001/Food_Ordering_Website"
              />
            </Col>
            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={gymmanagement}
                isBlog={false}
                title="Gym Management System"
                description="Gym management system with user interface for members and admin database for records."
                ghLink="https://github.com/anmolkumar1001/Gym-Management-System"
              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={musicwebsite}
                isBlog={false}
                title="Music Website"
                description="A website or platform where users can access, listen to, and download songs."
                ghLink="https://github.com/anmolkumar1001/Online-Music-Website"
              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={employeemanage}
                isBlog={false}
                title="Employee Management Portal"
                description="A website or portal where administrators and employees can create, manage, and update their profiles."
                ghLink="https://github.com/anmolkumar1001/Employee-Management-Portal"
              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={uidesign}
                isBlog={false}
                title="UI Design"
                description="UI using HTML, CSS, Bootstrap with video."
                ghLink="https://github.com/anmolkumar1001/UI-Design"
              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={chatwithgpt}
                isBlog={false}
                title="Chat with GPT"
                description="Chat with GPT is an android app that provides users with a conversational AI experience."
                ghLink="https://github.com/anmolkumar1001/ChatWithGPT_Using_Firebase"
              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={quizapp}
                isBlog={false}
                title="Quiz App"
                description="Quiz App using Kotlin programming language and Android API's."
                ghLink="https://github.com/anmolkumar1001/QuizApp"
              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={workoutapp}
                isBlog={false}
                title="Workout App"
                description="Workout App using Kotlin programming language and Android API's."
                ghLink="https://github.com/anmolkumar1001/Workout-App"
              />
            </Col>
          </Row>
        </Container>
      </Container>
    </div>
  );
}

export default Projectlist;
